import React from 'react';
import Loader from './ui/Loader';

export const LoadingSpinner = React.memo(function LoadingSpinner(props: React.ComponentProps<typeof Loader>) {
  return <Loader {...props} />;
});
